import { types } from 'mobx-state-tree';
import { RequestStateModel } from 'store/models/general-models';

export const Statuses = types.model('MessengerStatuses', {
  getConversations: types.optional(RequestStateModel, {}),
  getConversation: types.optional(RequestStateModel, {}),
  createConversation: types.optional(RequestStateModel, {}),
  getConversationsCounters: types.optional(RequestStateModel, {}),
});
